<template>


  <h3>Přihlašování na tréninky</h3>
  <h5>Individuální tréninky</h5>
    <p>Podle toho, co&nbsp;chcete se svým psem řešit může individuální trénink probíhat venku nebo přímo u&nbsp;vás doma.</p>
    <h6>Cena</h6>
    <p>700 Kč za&nbsp;první hodinu tréninku<br>
      za&nbsp;každou další započatou čtvrthodinu si účtuji 100&nbsp;Kč<br>
      při pravidelných individuálních trénincích se od druhého tréninku cena první hodiny každé lekce snižuje na 600&nbsp;Kč</p>
    <h6>Doprava</h6>
      <p>Za dopravu si účtuji 6 Kč/km (počítám vzdálenost jen jedním směrem - tedy pokud jste 20 km od Rožďalovic, je cena za dopravu 120 Kč)<br>
      tento poplatek neúčtuji, pokud se trénink koná v&nbsp;Rožďalovicích nebo pokud jste přihlášeni na&nbsp;předem vypsaný trénink</p>
  
  <h5>ZKO Nymburk - kurzy</h5>
    <p>Přihlašování je přes <a href="https://zko-nymburk.dogres.cz/trainings?trainer_id=924" target="_blank">dogres ZKO</a>.<br>
      Kurzy na rozdíl od jednotlivých lekcí nejsou hrazeny kreditovým systémem</p>
    <p>  
      Další kurzy začnou na přelomu května a června a budou probíhat v úterky a soboty/neděle. Zatím je vypsaný první z nich:<br>
      <!--<a href="https://zko-nymburk.dogres.cz/trainings/465354" target="_blank"><b>Pozornost a přivolání</b></a> - sobota<br>
      <a href="https://zko-nymburk.dogres.cz/trainings/487905" target="_blank"><b>Péče a ošetření</b></a> - sobota<br>
      <a href="https://zko-nymburk.dogres.cz/trainings/496945" target="_blank"><b>Pozornost a přivolání</b></a> - úterý<br>  
      <a href="https://zko-nymburk.dogres.cz/trainings/480709" target="_blank"><b>Kurz pro reaktivce - jak být s&nbsp;ostatními psy a lidmi v&nbsp;pohodě</b> - sobota</a><br>
      <a href="https://zko-nymburk.dogres.cz/trainings/503276" target="_blank"><b>Od všeho trochu - kurz pro pokročilé</b></a> - soboty<br>  
      <a href="https://zko-nymburk.dogres.cz/trainings/501256" target="_blank"><b>Základy rodinného psa</b></a> - úterý<br>-->
      <a href="https://zko-nymburk.dogres.cz/trainings/508911" target="_blank"><b>Péče a ošetření</b></a> - soboty<br>
    </p>  
    <!--
      <b>úterý večer:</b>
      <p>
      <a href="https://zko-nymburk.dogres.cz/trainings/451073" target="_blank"><b>Základy rodinného psa 2.0 pro&nbsp;psy všeho věku&nbsp;</b></a> - soboty odpoledne<br>
             
      <a href="https://zko-nymburk.dogres.cz/trainings/423166" target="_blank"><b>Základy rodinného psa  pro&nbsp;psy všeho věku&nbsp;</b></a> - PLNO!<br>
      <a href="https://zko-nymburk.dogres.cz/trainings/423175" target="_blank"><b>Pozornost a přivolání</b></a> - PLNO!<br>
      <a href="https://zko-nymburk.dogres.cz/trainings/478821" target="_blank"><b>Základy rodinného psa  pro&nbsp;psy všeho věku&nbsp;</b></a> - soboty dopoledne<br>   
      </p>  
    <b>sobota:</b>
      <p><a href="https://zko-nymburk.dogres.cz/trainings/423152" target="_blank"><b>Kurz pro reaktivce - jak být s&nbsp;ostatními psy a lidmi v&nbsp;pohodě</b></a></p>
    <p>Další kurzy začnou v druhé polovině září<br>
    -->

  <h5>ZKO Pardubice Dukla - kurzy</h5>
    <p>Další mé kurzy v Pardubicích v <a href="https://zkodukla.cz/" target="_blank">ZKO Dukla</a> budou probíhat opět ve středu</p>  
    <p>
      <a href="https://clovek-a-pes-spolu.dogres.cz/trainings/516090" target="_blank"><b>Základy rodinného psa 2.0 pro psy všeho věku</b></a><br>
      <!--<a href="https://clovek-a-pes-spolu.dogres.cz/trainings/451602" target="_blank"><b>Kurz pro reaktivce - jak být s ostatními psy a lidmi v pohodě - verze 2.0</b></a><br>
      <a href="https://clovek-a-pes-spolu.dogres.cz/trainings/503261" target="_blank"><b>Od všeho trochu - kurz pro pokročilé</b></a><br>  --> 
      <a href="https://clovek-a-pes-spolu.dogres.cz/trainings/516099" target="_blank"><b>Pozornost a přivolání</b></a><br>
      
      
    </p>


  <h5>Ždánice u Kouřimi - kurzy</h5>
    <p>Nově se můžeme potkávat ve Ždánici kousek od Kouřimi a Kostelce nad Černými Lesy. Cvičit budeme v <b>pátek večer</b>.<br>
    Další kurzy otevřu na konci května.</p>  

    <p>
      <a href="https://clovek-a-pes-spolu.dogres.cz/trainings/455480" target="_blank"><b>Pozornost a přivolání</b></a><br>
      <!--<a href="https://clovek-a-pes-spolu.dogres.cz/trainings/455518" target="_blank"><b>Základy rodinného psa 2.0 pro psy všeho věku</b></a> -->
    </p>



  <h5>Mladá Boleslav - kurzy</h5>
    <p>Další kurzy v Boleslavi začnou na jaře.</p>
    <p>V tuto chvíli se můžete hlásit na:<br>
    <a href="https://clovek-a-pes-spolu.dogres.cz/trainings/503244" target="_blank" ><b>Základy rodinného psa 2.0 - kurz pro psy všeho věku </b></a> - PLNO!<br>
    </p>
    <!--<a href="https://clovek-a-pes-spolu.dogres.cz/trainings/423433" target="_blank" ><b>Pozornost a přivolání</b></a>
    -->
    <!--<p>Předpokládám start dalšího běhu na začátku příštího roku. Veškeré informace budou jako vždy zde i na <a href="https://clovek-a-pes-spolu.dogres.cz/trainings" target="_blank">mém dogresu</a> </p> -->

  <!--<h5>Jičín - kurzy</h5>
  <p>Další kurzy v Jičíně začaly <b>25.9.</b></p> v tuto chvíli je poslední volné místo a <a href="https://clovek-a-pes-spolu.dogres.cz/trainings/334789" target="_blank" >přihlásit se můžete zde</a>
  <p>Start dalšího běhu ředpokládám na začátku příštího roku. Veškeré informace budou jako vždy zde i na <a href="https://clovek-a-pes-spolu.dogres.cz/trainings" target="_blank">mém dogresu</a> </p>
    Přihlašování je přes <a href="https://clovek-a-pes-spolu.dogres.cz/trainings" target="_blank">můj dogres</a> 
  a hlásíte se na první tréninkovou lekci. Týden před ní proběhne ještě úvodní teoretická lekce - určená pro školku a základy rodinného psa, nicméně vy, kdo se přihlásíte na přivolávače, si ji určitě můžete také přijít poslechnout :).</p>-->
  <!--<p>Nové kurzy v Jičíně začnou v dubnu</p>
  <p>Přihlásit se můžete na následující kurzy:<br>
  <a href="https://clovek-a-pes-spolu.dogres.cz/trainings/365156" target="_blank"><b>Základy rodinného psa 2.0 - kurz pro psy všeho věku</b></a> - začínáme 26. 2.<br>
  <a href="https://clovek-a-pes-spolu.dogres.cz/trainings/365217" target="_blank"><b>Pozornost a přivolání</b></a> - začínáme 9. 4. </p>-->

  <!--<h5>hala Osenice - kurzy</h5>
    <p>Kurzy v&nbsp;Osenicích začaly v prosinci a budou ve čtvrtek večer<br> Příští kurzy v Osenické hale budu pravděpodobně otevírat až příští zimu.</p>
  -->

  <h5>ZKO Nymburk - jednotlivé tréninky</h5>
    <p>Na tréninky v rámci <a href="https://zkonymburk.blogspot.com/" target="_blank">ZKO Nymburk</a> se přihlašujte přes <a href="https://zko-nymburk.dogres.cz/trainings?trainer_id=924" target="_blank">dogres ZKO</a>. 
    Na&nbsp;cvičáku funguje kreditový systém, pro přihlášení je tedy nutné mít zakoupené kredity.</p>
    <!--<iframe src="https://zko-nymburk.dogres.cz/trainings?trainer_id=924" width="100%" height="400px"></iframe>-->


  <h5>Skupinové tréninky a socializační procházky v Mladé Boleslavi</h5>
    <!--<p>Vypisuji spíše sporadicky. Pokud jsou, najdete je na <a href="https://clovek-a-pes-spolu.dogres.cz/trainings" target="_blank">mém dogresu.</a></p>
    <p>Pokud vypsané nejsou a měli byste o skupinku zájem, <router-link to="/kontakt">napište mi</router-link>, něco vymyslíme :)</p>
    <p>Od dubna 2024 jsem vypsala tréninky a socializační vycházky na pondělní a čtvrteční podvečer do Mladé Boleslavi a úterní/středeční podvečer do Jičína.
      <p>Jičín přihlašování <a href="https://clovek-a-pes-spolu.dogres.cz/trainings?place_id=484" target="_blank">ZDE</a>.</p>-->
    <p>Přihlašování<a href="https://clovek-a-pes-spolu.dogres.cz/trainings?place_id=1099" target="_blank"> ZDE</a>.</p>



    <p><b>Těším se na vás!</b></p>

</template>

<script>
import { useMeta } from 'vue-meta'

export default {
  setup () {
    useMeta({ title: 'Člověk a pes spolu - trenér psů Zdenka Cihlářová - přihlašování na tréninky a kurzy' })
  },


}
</script>

